/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-08-16T18:06:35.508
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialPreOrder,
	listFinancialPreOrderInit,
	listFinancialPreOrderByAuthorizations,
	deleteFinancialPreOrder
	
} from '@api/financial/FinancialPreOrder';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialPreOrder({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPreOrder(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPreOrderByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPreOrderByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPreOrderInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPreOrderInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialPreOrder({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialPreOrder({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
